import { Card, CardContent } from '@/components/ui/card';
import { SrIcon } from '@/components/ui/SrIcon';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface WidgetCardProps {
  children: ReactNode;
  /** Inner padding override. Default matches the redesigned widgets: "p-[30px]". */
  padding?: string;
  /** Klasser på ytterkortet (layout: flex-1, min-w-0 osv.). */
  className?: string;
  /** Klasser på innholds-containeren. */
  contentClassName?: string;
}

/** Standard card wrapper for Måltall widgets. Handles loading/error shells. */
export function WidgetCard({ children, padding = 'p-[30px]', className, contentClassName }: WidgetCardProps) {
  return (
    <Card className={className}>
      <CardContent className={cn(padding, contentClassName)}>{children}</CardContent>
    </Card>
  );
}

/** Shared loading skeleton card. */
export function WidgetCardLoading({ height = 'h-48' }: { height?: string }) {
  return (
    <Card>
      <CardContent className={cn('flex items-center justify-center', height)}>
        <SrIcon name="loader2" className="w-4 h-4 animate-spin text-muted-foreground" />
      </CardContent>
    </Card>
  );
}

/** Shared error shell card. */
export function WidgetCardError({ message }: { message: string }) {
  return (
    <Card>
      <CardContent className="flex items-center justify-center h-32 text-sm text-red-600">
        {message}
      </CardContent>
    </Card>
  );
}
